import { Component, OnInit, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-rpt-non-moving-items',
  templateUrl: './rpt-non-moving-items.component.html',
  styleUrls: ['./rpt-non-moving-items.component.scss']
})
export class RptNonMovingItemsComponent implements OnInit {

 //Table sort and column
 displayedColumns: string[] = ['ItemName', 'categoryName','subCategoryName','priority', 'MinLevel', 'StockQty', 'ValueRate', 
                                'LastUsedDT', 'days', 'LeadTime'];
 dataSource = new MatTableDataSource();

 @ViewChild('mtlAviaTable', { static: false }) mtlAviaTable!: ElementRef;
 SpinnerService: any;

 @ViewChild(MatPaginator)
 set paginator(value: MatPaginator) {
   this.dataSource.paginator = value;
 }

 @ViewChild(MatSort) set matSort(sort: MatSort) {
   this.dataSource.sort = sort;
 }

 ngAfterViewInit() {
   this.dataSource.paginator = this.paginator;
   this.dataSource.sort = this.matSort;
 }

 //Variable Declaration
 agencyData: any = [];
 jarvisData: any = [];
 nonMovingStockList: any = [];
 exportToExcel: any = [];
 unitList:any = [];
 productListData:any = [];
 ItemCategories:any = [];
 subCategoryList:any = [];
 copyData:any = [];
 productList: any = {
   prodID: "0",
   name: '',
   unitName: '',
   unitID: "0",
   qty: "",
   prcn: "0"
 }
 itemImportant : Array<any> = [{
  id: '0',
  itemType: 'Low'
},{
  id: '1',
  itemType: 'High'
},
{
  id: '2',
  itemType: 'Normal'
}]

 filter: any = {
  priorityTypeID: '-1',
  cateID: '0',
  subCateID: '0',
  lastUsedDays: '',
  cateName: '',
  subCateName: '',
  itemTypeName: '',
  unusedFor: ''
 }

 Items:any = '[]';
 statusID: number = 1;

 constructor(private apiService: APIService, public CmnService: CommonService, private router: Router, private SpinnerServices: NgxSpinnerService) { }

 ngOnInit(): void {
     //Get Item Categories and sub-categories 
    let erpCfg = this.apiService.getCookie("ERP_Cfg");
    if (erpCfg) {
      let erpCfgData = JSON.parse(erpCfg);
      if(erpCfgData.length > 0){
        let catData = erpCfgData[0].ItemCategories;
        if(catData){
          this.ItemCategories = JSON.parse(catData);
          //this.ItemCategories =  this.ItemCategories.sort((a: any,b: any) =>  (a.cnm) - (b.cnm))
         this.ItemCategories = this.ItemCategories.sort((a: any, b: any) => a.cnm.localeCompare(b.cnm));
        }
      }    
    }
     this.getData();
 }

 //getData() - "Get non moving stock data"
 getData() { 
   let agencyData = this.apiService.getCookie('M');
   if (agencyData) {
     this.agencyData = JSON.parse(agencyData);
   }
   var jarvis = this.apiService.getCookie('Jarvis');
   if (jarvis) {
     this.jarvisData = JSON.parse(jarvis);
   }
  let data = [{}];
  let myParams = [
    {
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'getNonMovingItems',
      moduleID: 12,
      data: JSON.stringify(data),
    },
  ];
   this.SpinnerServices.show();
   this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this)
   );
 }
 
 //Success Response - Success handler
 successResp(res: any) {
   this.SpinnerServices.hide();
   if (res.error) {
   }
   else {
     if (res) {
       var reponseData = JSON.parse(res.updatePackage);
       if (reponseData.Table[0].ErrCode != '-1') {
         alert(reponseData.Table[0].ErrMsg);
       } else {
         if (reponseData.Table[0].ErrCode == -1) {
           this.nonMovingStockList = reponseData.Table1;
           this.nonMovingStockList = this.nonMovingStockList.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
           console.log(this.nonMovingStockList)
           this.dataSource.data = this.nonMovingStockList;
           this.exportToExcel = this.nonMovingStockList;
           this.dataSource.paginator = this.paginator;
           this.dataSource.sort = this.matSort;
           this.nonMovingStockList.forEach((c: any) => {
            let catData: any = $.grep(this.ItemCategories, function(o: any){ return o.cid == c.CategoryID });
            if(catData.length > 0){
              c.categoryName = catData[0].cnm;
              let subCatData = catData[0].sub;
               if(subCatData.length > 0){
                let selSubCat =  $.grep(subCatData, function(o: any){ return o.sid == c.SubCategoryID })
                if (selSubCat.length > 0) {
                  c.subCategoryName = selSubCat[0].snm; //subCatData[0].snm;
                }
                }
            } 
            if(c.PriorityID == 0){
              c.priority = 'Low'
            }
            else if(c.PriorityID == 1){
              c.priority = 'High'
            }
            else if(c.PriorityID == 2){
              c.priority = 'Normal'
            }
            //Date Diffrance  
            if(c.LastUsedDT){
              let date1: any = new Date();
              let date2: any = new Date(c.LastUsedDT);
              let diffTime = Math.abs(date2 - date1);
              let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
              c.days = diffDays
            }
            else{
              c.days = ''
            }
            c.StockQty = Number(c.StockQty).toFixed(c.SKU)
            this.copyData = this.nonMovingStockList
          });
         }
       }
     }
   }
 }

 //failureResp - failure handler
 failureResp(res: any) {
   if (res.error) {
   } else {
     alert(res.message);
   }
 }

 //applyFilter() - "Search data"
 applyFilter(event: Event) {
   const filterValue = (event.target as HTMLInputElement).value;
   this.dataSource.filter = filterValue.trim().toLowerCase();
   if (this.dataSource.paginator) {
     this.dataSource.paginator.firstPage();
   }
 }

 //successRespItem() - "successResp - success get handler"
 /*successRespItem(res: any) {
   this.SpinnerService.hide();
   if (res.error) {
   }
   else {
     if (res) {
       var reponseData = JSON.parse(res.updatePackage);
       if (reponseData) {
         let data = reponseData;
         let tempItems = data.Table1;
         this.productList = tempItems
         this.apiService.setIDB('erp_inv', this.productList);
       }
     }
   }
 }*/

 //failureRespItem() - "failureResp - failure handler"
 failureRespItem(res: any) {
   if (res.error) {
   }
   else {
     alert(res.message);
   }
 }

 //changeCategory() - "Change category filter"
 changeCategory(){
  if(this.filter.cateID){
    let selectSubCate = this.ItemCategories.filter((x: any) => x.cid == this.filter.cateID);
    if(selectSubCate.length > 0){
      this.subCategoryList = selectSubCate[0].sub;
      this.subCategoryList = this.subCategoryList.sort((a: any, b: any) => a.snm.localeCompare(b.snm));
      }
    }
    else{
    this.subCategoryList = [];
    }
    this.changeFilterApply();
  }

  //changeFilterApply() - "Change apply filter"
  changeFilterApply(){
  let filterDataList = this.copyData;
    //Cheack Category Filter
    if(this.filter.cateID > 0){
      let selectCateList = filterDataList.filter((x: any) => x.CategoryID == this.filter.cateID);
      filterDataList = selectCateList;
    }
    //Cheack Sub Category Filter
    if(this.filter.subCateID > 0){
      let selectSubCateList = filterDataList.filter((x: any) => x.SubCategoryID == this.filter.subCateID);
      filterDataList = selectSubCateList;
     
    }
    //Check Priority Filter
    if(this.filter.priorityTypeID != '-1'){
      let selectPriorityList = filterDataList.filter((x: any) => x.PriorityID == this.filter.priorityTypeID);
      filterDataList = selectPriorityList;
    }
    //Check Last Used day wise filter
    if(this.filter.lastUsedDays != ''){
      let selectLastDaysList = filterDataList.filter((x: any) => (x.days ? x.days <= this.filter.lastUsedDays : ''));
      filterDataList = selectLastDaysList;
    }

  filterDataList = filterDataList.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
  this.nonMovingStockList = filterDataList;
  this.dataSource.data = filterDataList;
  this.exportToExcel = filterDataList;
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.matSort;
  this.ItemCategories = this.ItemCategories.sort((a: any, b: any) => a.cnm.localeCompare(b.cnm));
  this.subCategoryList = this.subCategoryList.sort((a: any, b: any) => a.snm.localeCompare(b.snm));
  this.itemImportant = this.itemImportant.sort((a: any, b: any) => a.itemType.localeCompare(b.itemType));
  this.filter.itemTypeName =  filterDataList[0].priority;
  this.filter.cateName = filterDataList[0].categoryName;
  this.filter.subCateName =filterDataList[0].subCategoryName;
  this.filter.unusedFor = filterDataList[0].priority;
  }

//Export To Excel
   exportToExcelActivities() {
     var html = "";
     // Title
     html += "<table><tr>";
     html += "<th style='text-align: left;'>Non Moving Stock</th>"
     html += "</table></tr>";
     html += "<table><tr></table></tr>";
     html += "<table><tr>";

    //Hader Title - "Filter wise"
    if(this.filter.cateID > 0)
    {
    html += "<p><b> Category : </b>" + this.filter.cateName + "</p>"
    }
    if(this.filter.subCateID > 0)
    {
      html += "<p><b> Sub Category : </b>" + this.filter.subCateName + "</p>"
    }
    if(this.filter.priorityTypeID != '-1')
    {
      html += "<p><b> Priority : </b>" + this.filter.itemTypeName + "</p>"
    }
    
    if(this.filter.lastUsedDays != '')
    {
      html += "<p><b> Last Unused for : </b>" + this.filter.lastUsedDays + " Days ago"+ "</p>"
    }

     // Blank Column
     html += "<table><tr>";
     var strHeader = ""
     strHeader += "<th style='text-align: left;'>Product</th>";
     strHeader += "<th style='text-align: left;'>Category</th>";
     strHeader += "<th style='text-align: left;'>Sub Category</th>";
     strHeader += "<th style='text-align: left;'>Priority</th>";
     strHeader += "<th style='text-align: right;'>Min Level</th>";
     strHeader += "<th style='text-align: right;'>Stock Qty</th>";
     strHeader += "<th style='text-align: right;'>Value (Rs.)</th>";
     strHeader += "<th style='text-align: left;'>Last Used</th>";
     strHeader += "<th style='text-align: left;'>Unused for</th>";
     strHeader += "<th style='text-align: left;'>Lead Time</th>";
     strHeader += "</tr>"
     html += strHeader;
     var body = "";
 
     this.exportToExcel.forEach((item: any, key: any) => {
       body += "<tr>";
       body += "<td style='text-align: left;'>" + item.ItemName + "</td>";
       body += "<td style='text-align: left;'>" + item.categoryName + "</td>";
       body += "<td style='text-align: left;'>" + (item.subCategoryName ? item.subCategoryName : '-') + "</td>";
       body += "<td style='text-align: left;'>" + (item.priority ? item.priority : '-') + "</td>";
       body += "<td style='text-align: right;'>" + (item.MinLevel ? item.MinLevel : '-') + "</td>";
       body += "<td style='text-align: right;'>" + (item.StockQty ? item.StockQty : '-') + "</td>";
       body += "<td style='text-align: right;'>" + (item.ValueRate ? item.ValueRate : '-') + "</td>";
       body += "<td style='text-align: left;'>" + (item.LastUsedDT ?  new Date(item.LastUsedDT).customFormat("#DD#-#MMM#-#YYYY#") : '-') + "</td>";
       body += "<td style='text-align: left;'>" + (item.days ? item.days : '-') +  (item.days ? (item.days > 1 ? ' Days' : ' Day') : '') + "</td>";
       body += "<td style='text-align: left;'>" + (item.LeadTime ? item.LeadTime : '-') + (item.LeadTime ? (item.LeadTime > 1 ? ' Days' : ' Day'): '') + "</td>";
       body += "</tr>";
     })
     
     html += body;
     html += "</table>";
     this.tableToExcel(html, 'Sheet1', 'Non Moving Stock');
   }
  
     //export to excel
 tableToExcel = (function () {
   var uri = 'data:application/vnd.ms-excel;base64,'
     , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
     , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
     , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

   return function (table: any, name: string, fileName: any) {
     if (!table.nodeType) table = table
     var ctx = { worksheet: name || 'Worksheet', table: table }
     //window.location.href = uri + base64(format(template, ctx))
     var link = document.createElement("a");
     link.download = fileName || 'download.xls';
     link.href = uri + base64(format(template, ctx));
     link.click();
   }
 })()

 backBtn() {
   this.router.navigate(['/Stock']);
 }

}
